import { AppShell } from "@theg1group/app-shell";
import { PagesRegistryProvider, type RegistryPage } from "@theg1group/rbac-ui";
import { Wallet } from "lucide-react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AUTH_URL } from "./config.ts";
import { AuthProvider } from "./lib/auth.tsx";
import { cryptonetworkNav } from "./nav.ts";
import { AddressDetail } from "./pages/AddressDetail.tsx";
import { Addresses } from "./pages/Addresses.tsx";
import { Alerts } from "./pages/Alerts.tsx";
import { CaseDetail } from "./pages/CaseDetail.tsx";
import { Cases } from "./pages/Cases.tsx";
import { ClusterDetail } from "./pages/ClusterDetail.tsx";
import { GraphPage } from "./pages/GraphPage.tsx";
import { Labels } from "./pages/Labels.tsx";
import { Overlap } from "./pages/Overlap.tsx";
import { Overview } from "./pages/Overview.tsx";
import { PartnerDetail } from "./pages/PartnerDetail.tsx";
import { Partners } from "./pages/Partners.tsx";
import { TraceDetail } from "./pages/TraceDetail.tsx";
import { Traces } from "./pages/Traces.tsx";

async function fetchPagesRegistry(): Promise<{ data: RegistryPage[] }> {
	const res = await fetch(`${AUTH_URL}/pages-registry`, { credentials: "include" });
	if (!res.ok) throw new Error(`pages-registry ${res.status}`);
	return (await res.json()) as { data: RegistryPage[] };
}

export function App() {
	return (
		<AuthProvider>
			<PagesRegistryProvider appId="cryptonetwork" fetchRegistry={fetchPagesRegistry}>
				<AppShell
					appId="cryptonetwork"
					authUrl={AUTH_URL}
					features={[cryptonetworkNav]}
					branding={{ title: "Crypto Network", Icon: Wallet }}
					requireAppAccess="cryptonetwork"
					require2FA={false}
				>
					<Routes>
						<Route path="/overview" element={<Overview />} />
						<Route path="/partners" element={<Partners />} />
						<Route path="/partners/:id" element={<PartnerDetail />} />
						<Route path="/addresses" element={<Addresses />} />
						<Route path="/addresses/:id" element={<AddressDetail />} />
						<Route path="/clusters/:id" element={<ClusterDetail />} />
						<Route path="/graph" element={<GraphPage />} />
						<Route path="/overlap" element={<Overlap />} />
						<Route path="/traces" element={<Traces />} />
						<Route path="/traces/:id" element={<TraceDetail />} />
						<Route path="/alerts" element={<Alerts />} />
						<Route path="/labels" element={<Labels />} />
						<Route path="/cases" element={<Cases />} />
						<Route path="/cases/:id" element={<CaseDetail />} />
						<Route path="*" element={<Navigate to="/overview" replace />} />
					</Routes>
				</AppShell>
			</PagesRegistryProvider>
		</AuthProvider>
	);
}
